export const config = {
    name: "production",
    baseApiUrl: "https://concentric.ink/.netlify/functions",
    baseWebUrl: "https://concentric.ink",
    twitterCallback: `https://${window.location.hostname}/twitter-callback`,
};
